module.exports = __webpack_public_path__ + "img/Ripple-2s-100px.d71565c1.svg";